var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "checkout-shipping-page-container" }, [
      _c("section", { staticClass: "text-center bg-white main-heading-page" }, [
        _c("h2", [
          _vm._v(
            " \n                " +
              _vm._s(_vm.$resourceString["checkout.Title.Shipping"]) +
              "\n            "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row align-items-start" }, [
          _c("div", { staticClass: "col-12 col-lg-8 col-xl-9" }, [
            _c("div", { staticClass: "checkout-shipping-page-wrap" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c(
                    "h5",
                    { staticClass: "primary-heading font-weight-bold" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$resourceString["checkout.Shipping.Label.Samples"]
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.checkoutItemList.trayItems.length > 0
                  ? _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "checkout-shipping-designtray-note" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.$resourceString["common.Note"]) + ":"
                            )
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$resourceString["checkout.Note.DesignTray"]
                              ) +
                              "\n                                "
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-5 col-sm-6 col-12" }, [
                  _c(
                    "div",
                    { staticClass: "checkout-shipping-page-details-col" },
                    [
                      _c("div", { staticClass: "details-label-heading" }, [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$resourceString["checkout.Shipping.To"]
                            ) + ":"
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "details-body" }, [
                        _vm.getCurrentAddressIndex &&
                        Object.keys(_vm.currentAddress).length > 0
                          ? _c(
                              "div",
                              { staticClass: "details-body-shipping-address" },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.currentAddress.firstName) +
                                      " " +
                                      _vm._s(_vm.currentAddress.lastName)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                                                " +
                                      _vm._s(
                                        _vm.currentAddress.streetLine2
                                          ? _vm.currentAddress.streetLine1 +
                                              ", Suite" +
                                              _vm.currentAddress.streetLine2
                                          : _vm.currentAddress.streetLine1
                                      ) +
                                      ".\n                                            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.currentAddress.city) +
                                      ", " +
                                      _vm._s(_vm.currentAddress.state) +
                                      ", " +
                                      _vm._s(_vm.currentAddress.postalCode) +
                                      ", " +
                                      _vm._s(_vm.currentAddress.country) +
                                      "."
                                  )
                                ])
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "details-body-shipping-address" },
                              [_c("span", [_vm._v("-")])]
                            )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "details-footer" }, [
                        _c(
                          "a",
                          {
                            ref: "addressModal",
                            attrs: {
                              href: "#",
                              "data-toggle": "modal",
                              "data-backdrop": "static",
                              "data-target": "#addressModal"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.openAddressModal(false, 0, 0)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                          " +
                                _vm._s(
                                  _vm.$resourceString[
                                    "checkout.Shipping.Button.AddOrChangeAddress"
                                  ]
                                ) +
                                "\n                                        "
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.checkoutItemList.siteItems.length > 0 ||
                _vm.checkoutItemList.projectItems.length > 0
                  ? _c("div", { staticClass: "col-md-7 col-sm-6 col-12" }, [
                      _c(
                        "div",
                        { staticClass: "checkout-shipping-page-details-col" },
                        [
                          _c("shipping-options", {
                            attrs: {
                              shippingOptionData:
                                _vm.checkoutData.ShippingOption,
                              zCode: _vm.currentAddressZipCode,
                              createStudio: _vm.createStudio
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-12 col-lg-4 col-xl-3 sidebar-position-sticky sidebar-mobile-device"
            },
            [
              _c("div", { staticClass: "checkout-basket-sidebar-warpper" }, [
                _c(
                  "div",
                  { staticClass: "checkout-basket-sidebar-container" },
                  [
                    _c("pc-basket-sidebar", {
                      attrs: {
                        individualSamples:
                          _vm.checkoutItemList.siteItems.length > 0,
                        individualSamplesCount: _vm.checkoutItemCount.siteItems,
                        projectSamples:
                          _vm.checkoutItemList.projectItems.length > 0,
                        projectSamplesCount: _vm.checkoutItemCount.projectItems,
                        designTraySample:
                          _vm.checkoutItemList.trayItems.length > 0,
                        designTraySampleCount: _vm.checkoutItemCount.trayItems,
                        backLabel:
                          _vm.$resourceString["myBasket.Button.BackToBasket"],
                        backAction: _vm.backHandler,
                        nextLabel:
                          _vm.$resourceString[
                            "checkout.Button.ContinueToProject"
                          ],
                        nextAction: _vm.continueToCheckoutHandler,
                        isNextDisabled:
                          !_vm.getCurrentAddressIndex ||
                          !_vm.checkoutData.ShippingOption
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }